'use strict'

const DbHelpers = require('./db-helpers')
const Policy = require('./policy.js')
const Util = require('../common/util.js')
const Q = require('q')

class AccessPolicy {

    constructor(document, getProperties) {
        this._evaluatedPolicy = null
        this._needsEvaluation = true
        this._policies = []
        this.fetchProperties = getProperties
        if (undefined !== document) {
            this.mergeDocument(document)
        }
    }

    evaluate() {
        if (!this._needsEvaluation) {
            return Q(this._evaluatedPolicy)
        }
        this._evaluatedPolicy = this._policies.reduce((acc, nextPolicy) => {
            return acc.mergeWith(nextPolicy)
        }, this._policies.pop())
        this._needsEvaluation = false
        return Q(this._evaluatedPolicy)
    }

    mergeDocument(document) {
        this._needsEvaluation = true
        const policy = Policy.create(document, this.fetchProperties)
        this._policies.push(policy)
        return this
    }

    mergePolicy(accessPolicy) {
        return accessPolicy.toStringPromise()
            .then(s => {
                const document = JSON.parse(s)
                return this.mergeDocument(document)
            })
    }

    getProperties(type) {
        return this.evaluate()
            .then(p => p.getProperties(type))
    }

    toStringPromise() {
        return this.evaluate()
            .then(p => {
                return p.toString()
            })
    }

}

/**
 * Factory function for creating an AccessPolicy for a user with a given set of
 * principals.  Database helpers must be supplied to allow the underlying code
 * to request data that it requires.
 * @param principals
 * @param helpers
 * @returns {AccessPolicy}
 */
const forPrincipals = (principals, helpers) => {
    const policy = new AccessPolicy(undefined, helpers.getProperties)
    return helpers.getPoliciesForPrincipals(principals)
        .then((results) => {
            return results.reduce((p, next) => {
                return p.mergeDocument(next)
            }, policy)
        })
}

const fromStatements = (statements, helpers) => {
    const policy = Policy.create(undefined, helpers.getProperties)
    statements.forEach(statement => {
        const actions = statement.Action || []
        actions.forEach(action => {
            const a = Util.parseAction(action)
            policy.addAction(
                a.service,
                a.activity,
                statement.Resource,
                statement.Effect
            )
        })
    })
    const document = JSON.parse(policy.toString())
    return new AccessPolicy(document, helpers.getProperties)
}

module.exports = {
    forPrincipals,
    fromStatements,
    getDbHelpers: DbHelpers.getHelpers
}



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/access-policy/index.js
// module id = 159
// module chunks = 51